import React from 'react'

import { Box } from '@chakra-ui/react'

interface DeviceModalHeaderIProps {
  title: string
}

export const DeviceModalHeader = ({ title }: DeviceModalHeaderIProps) => {
  return (
    <Box p='6'>
      <Box>
        <Box
          color='#353849'
          fontSize='26px'
          fontWeight='bold'
          letterSpacing='-0.4px'
          lineHeight='1'
        >
          {title}
        </Box>
      </Box>
    </Box>
  )
}
